export const SELECT_ALL_KEY = "__SELECT_ALL__";

export const SELECT_ALL_OPTION = {
  name: "Selecionar todos",
  key_: SELECT_ALL_KEY,
  applicationName: SELECT_ALL_KEY,
};

export const CUSTOM_ITEMS = [
  {
    name: "Inteiro",
    key_: "int",
    applicationName: "CUSTOM",
  },
  {
    name: "Float",
    key_: "float",
    applicationName: "CUSTOM",
  },
  {
    name: "Boleano",
    key_: "boolean",
    applicationName: "CUSTOM",
  },
];
